import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import React from "react";
import {FaArrowLeft} from "react-icons/fa";

interface PropsI {
    prevPage: ()=>void;
    nextPage: (values: any) => void;
}

const NameInformation = ({ prevPage, nextPage }: PropsI)=>{
    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("First name is required"),
        middleName: Yup.string().required("Middle name is required"),
        lastName: Yup.string().required("Last name is required"),
    });

    const { handleSubmit, register, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            firstName: "",
            middleName: "",
            lastName: "",
        }
    });

    const isFormValid = errors.firstName?.message || errors.middleName?.message || errors.lastName?.message;

    const onSubmit = (values: any) =>{
        nextPage(values)
    }

    return (
        <div>
            <div className="flex ">
                <button className="btn btn-outline mb-4" onClick={prevPage}>
                    <FaArrowLeft className="mr-2"/>
                    Back
                </button>
            </div>
            <div className="input_container">
                <label className="input_title" htmlFor="first-name">
                    First Name
                </label>
                <input
                    id="first-name"
                    className="input_field"
                    type="text"
                    placeholder={"Enter first name"}
                    {...register("firstName")}
                />
                {errors.firstName && (
                    <ErrorViewer message={errors.firstName.message as string} />
                )}
            </div>
            <div className="input_container">
                <label className="input_title" htmlFor="first-name">
                    Middle Name
                </label>
                <input
                    id="middle-name"
                    className="input_field"
                    type="text"
                    placeholder={"Enter middle name"}
                    {...register("middleName")}
                />
                {errors.middleName && (
                    <ErrorViewer message={errors.middleName.message as string} />
                )}
            </div>
            <div className="input_container">
                <label className="input_title" htmlFor="last-name">
                    Last Name
                </label>
                <input
                    id="last-name"
                    className="input_field"
                    type="text"
                    placeholder={"Enter last name"}
                    {...register("lastName")}
                />
                {errors.lastName && (
                    <ErrorViewer message={errors.lastName.message as string} />
                )}
            </div>

            <button
                type="submit"
                className="btn btn-primary btn-primary-full"
                // style={{ backgroundColor: !!isFormValid ? "#305F32" : "#77bb7b" }}
                style={{ backgroundColor:"#305F32" }}
                disabled={!!isFormValid}
                onClick={handleSubmit(onSubmit)}
            >
                Continue
            </button>
        </div>
    )
}

export default NameInformation;